import {
  ProductTabContent,
  ProductTabNav,
  ProductTabNavItem,
  ProductTabPane,
} from './ProductTab';
import {useRouter} from 'next/router';
import {ProductTabImagePane} from './ProductTab/product-tab-image-pane';
import {useTranslation} from 'next-i18next';
import {useEffect, useState} from 'react';
import {ContentContainer} from '@interfaces/content-container';
import {ImageInterface} from '@interfaces/images';
import {LocaleEnum} from '@enums/locale';

export default function ProductDisplayTab(props: {
  productGroupUID: string;
  productName: string;
  tabs: ContentContainer[];
  content_container: ContentContainer;
  images: ImageInterface[];
}) {
  const router = useRouter();
  const locale = router.locale as LocaleEnum;
  const {images, content_container, tabs, productGroupUID, productName} = props;
  const [activeTab, setActiveTab] = useState(
    parseInt(router.query.tab as string) || 0
  );
  const {t} = useTranslation('product-display');

  useEffect(() => {
    let tabIds = [];
    if (images.length > 0) tabIds.push(0);
    tabIds.push(content_container.id);
    tabIds = [...tabIds, ...tabs.map(tab => tab.id)];
    const queryTabId = tabIds.find(
      id => id === parseInt(router.query.tab as string)
    );
    setActiveTab(queryTabId || tabIds[0]);
  }, [router.query.tab]);

  const handleTabChange = (id: number) => {
    delete router.query.slug;
    let query: Record<string, unknown>;
    if (id === 0) {
      delete router.query.tab;
      query = router.query;
    } else query = {...router.query, ...{tab: id}};

    const queryArr = Object.keys(query).map(key => `${key}=${query[key]}`);
    router.push(`${location.pathname}?${queryArr.join('&')}`, undefined, {
      shallow: true,
    });
  };

  return (
    <>
      <ProductTabNav>
        {images.length > 0 && (
          <ProductTabNavItem
            isActive={activeTab === 0}
            setActiveTab={() => handleTabChange(0)}
          >
            {t<string>('product_display_tab.product_image')}
          </ProductTabNavItem>
        )}

        <ProductTabNavItem
          isActive={activeTab === content_container.id}
          setActiveTab={() => handleTabChange(content_container.id)}
        >
          {t<string>('product_display_tab.technical_information')}
        </ProductTabNavItem>
        {tabs.map(tab => {
          const tabName = tab['link_name'];
          return (
            <ProductTabNavItem
              setActiveTab={() => handleTabChange(tab.id)}
              isActive={activeTab === tab.id}
              key={tab.id}
            >
              {tabName}
            </ProductTabNavItem>
          );
        })}
      </ProductTabNav>
      <ProductTabContent>
        <ProductTabImagePane
          alt={`${productName}`}
          locale={locale}
          isActive={activeTab === 0}
          images={images}
        />
        <ProductTabPane
          tab={content_container}
          isActive={activeTab === content_container.id}
          productGroupUID={productGroupUID}
        />
        {tabs.map((tab, tabContentIndex) => {
          return (
            <ProductTabPane
              tab={tab}
              isActive={activeTab === tab.id}
              productGroupUID={productGroupUID}
              key={tabContentIndex}
            />
          );
        })}
      </ProductTabContent>
    </>
  );
}
